import { AGGREGATIONS, ITypeNameElement } from '../../platform/ts/ConfigurationConstants';

export const ATTRIBUTE_SINGLE_SELECTION_OPTION: ITypeNameElement = {
    type: 'single',
    name: 'Single'
};

export const ATTRIBUTE_MULTIPLY_SELECTION_OPTION: ITypeNameElement = {
    type: 'multiply',
    name: 'Multiple'
};

export const AGGREGATE_GROUP_VALUES: { [attributeType: string]: string[] } = {
    s: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX,
        AGGREGATIONS.STRING_AGG
    ],

    e: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX,
        AGGREGATIONS.STRING_AGG
    ],

    none: [AGGREGATIONS.GROUP, AGGREGATIONS.COUNT, AGGREGATIONS.COUNT_DISTINCT],

    i: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.SUM,
        AGGREGATIONS.SUM_DISTINCT,
        AGGREGATIONS.AVG,
        AGGREGATIONS.AVG_DISTINCT,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX
    ],

    r: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.SUM,
        AGGREGATIONS.SUM_DISTINCT,
        AGGREGATIONS.AVG,
        AGGREGATIONS.AVG_DISTINCT,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX
    ],

    b: [AGGREGATIONS.GROUP, AGGREGATIONS.COUNT, AGGREGATIONS.COUNT_DISTINCT, AGGREGATIONS.COUNT_NOT_NULL],

    datetime: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX
    ],

    date: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX
    ],

    time: [
        AGGREGATIONS.GROUP,
        AGGREGATIONS.COUNT,
        AGGREGATIONS.COUNT_DISTINCT,
        AGGREGATIONS.COUNT_NOT_NULL,
        AGGREGATIONS.MIN,
        AGGREGATIONS.MAX
    ]
};

export const FORMAT_VALUES: {
    [attributeType: string]: { format: string; comment: string }[];
} = {
    date: [
        { format: 'd', comment: 'Short date' },
        { format: 'dd', comment: 'Day of month' },
        { format: 'ddd', comment: 'Abbreviated day of week' },
        { format: 'dddd', comment: 'Name of the day of the week' },
        { format: 'D', comment: 'Long date' },
        { format: 'f', comment: 'Full date/short time' },
        { format: 'F', comment: 'Full date/long time' },
        { format: 'g', comment: 'General date/short time' },
        { format: 'G', comment: 'General date/long time' },
        { format: 'M', comment: 'Month/day pattern' },
        { format: 'MM', comment: 'Month from 1 to 12' },
        { format: 'MMM', comment: 'Abbreviated month name' },
        { format: 'MMMM', comment: 'Full name of month' },
        { format: 'O', comment: 'Round-trip date/time' },
        { format: 'R', comment: 'RFC1123' },
        { format: 's', comment: 'Sortable date/time' },
        { format: 't', comment: 'Short time' },
        { format: 'T', comment: 'Long time' },
        { format: 'u', comment: 'Universal sortable date/time' },
        { format: 'U', comment: 'Universal full date/time' },
        { format: 'y', comment: 'Year month' },
        { format: 'yy', comment: 'Year with two digits' },
        { format: 'yyyy', comment: 'Year with four digits' },

        { format: 'hh', comment: 'Hour from 0 to 11' },
        { format: 'HH', comment: 'Hour from 0 to 23' },
        { format: 'mm', comment: 'Minute from 0 to 59' },
        { format: 'ss', comment: 'Second from 0 to 59' },
        {
            format: 'z',
            comment: 'Hours offset from UTC, with no leading zeros'
        },
        {
            format: 'zz',
            comment: 'Hours offset from UTC, with a leading zero for a single-digit value'
        },
        { format: 'zzz', comment: 'Hours and minutes offset from UTC' },
        {
            format: 'ff',
            comment: 'Displays 2 most significant digits of the seconds fraction'
        },
        {
            format: 'fff',
            comment: 'Displays 3 most significant digits of the seconds fraction'
        },
        {
            format: 'ffff',
            comment: 'Displays 4 most significant digits of the seconds fraction'
        },
        {
            format: 'fffff',
            comment: 'Displays 5 most significant digits of the seconds fraction'
        },
        {
            format: 'ffffff',
            comment: 'Displays 6 most significant digits of the seconds fraction'
        },
        {
            format: 'fffffff',
            comment: 'Displays 7 most significant digits of the seconds fraction'
        },
        {
            format: 'FF',
            comment: 'Displays 2 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFF',
            comment: 'Displays 3 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFF',
            comment: 'Displays 4 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFFF',
            comment: 'Displays 5 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFFFF',
            comment: 'Displays 6 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFFFFF',
            comment: 'Displays 7 most significant digits of the seconds fraction, without trailing zeros'
        }
    ],

    datetime: [
        { format: 'd', comment: 'Short date' },
        { format: 'dd', comment: 'Day of month' },
        { format: 'ddd', comment: 'Abbreviated day of week' },
        { format: 'dddd', comment: 'Name of the day of the week' },
        { format: 'D', comment: 'Long date' },
        { format: 'f', comment: 'Full date/short time' },
        { format: 'F', comment: 'Full date/long time' },
        { format: 'g', comment: 'General date/short time' },
        { format: 'G', comment: 'General date/long time' },
        { format: 'M', comment: 'Month/day pattern' },
        { format: 'MM', comment: 'Month from 1 to 12' },
        { format: 'MMM', comment: 'Abbreviated month name' },
        { format: 'MMMM', comment: 'Full name of month' },
        { format: 'O', comment: 'Round-trip date/time' },
        { format: 'R', comment: 'RFC1123' },
        { format: 's', comment: 'Sortable date/time' },
        { format: 't', comment: 'Short time' },
        { format: 'T', comment: 'Long time' },
        { format: 'u', comment: 'Universal sortable date/time' },
        { format: 'U', comment: 'Universal full date/time' },
        { format: 'y', comment: 'Year month' },
        { format: 'yy', comment: 'Year with two digits' },
        { format: 'yyyy', comment: 'Year with four digits' },

        { format: 'hh', comment: 'Hour from 0 to 11' },
        { format: 'HH', comment: 'Hour from 0 to 23' },
        { format: 'mm', comment: 'Minute from 0 to 59' },
        { format: 'ss', comment: 'Second from 0 to 59' },
        {
            format: 'z',
            comment: 'Hours offset from UTC, with no leading zeros'
        },
        {
            format: 'zz',
            comment: 'Hours offset from UTC, with a leading zero for a single-digit value'
        },
        { format: 'zzz', comment: 'Hours and minutes offset from UTC' },
        {
            format: 'ff',
            comment: 'Displays 2 most significant digits of the seconds fraction'
        },
        {
            format: 'fff',
            comment: 'Displays 3 most significant digits of the seconds fraction'
        },
        {
            format: 'ffff',
            comment: 'Displays 4 most significant digits of the seconds fraction'
        },
        {
            format: 'fffff',
            comment: 'Displays 5 most significant digits of the seconds fraction'
        },
        {
            format: 'ffffff',
            comment: 'Displays 6 most significant digits of the seconds fraction'
        },
        {
            format: 'fffffff',
            comment: 'Displays 7 most significant digits of the seconds fraction'
        },
        {
            format: 'FF',
            comment: 'Displays 2 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFF',
            comment: 'Displays 3 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFF',
            comment: 'Displays 4 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFFF',
            comment: 'Displays 5 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFFFF',
            comment: 'Displays 6 most significant digits of the seconds fraction, without trailing zeros'
        },
        {
            format: 'FFFFFFF',
            comment: 'Displays 7 most significant digits of the seconds fraction, without trailing zeros'
        }
    ],

    i: [
        { format: 'c', comment: 'Currency' },
        { format: 'd', comment: 'Decimal' },
        { format: 'e', comment: 'Exponential' },
        { format: 'f', comment: 'Fixed-point' },
        { format: 'g', comment: 'General' },
        { format: 'p', comment: 'Percent' },
        { format: 'x', comment: 'Hexadecimal' }
    ],

    r: [
        { format: 'c', comment: 'Currency' },
        { format: 'd', comment: 'Decimal' },
        { format: 'e', comment: 'Exponential' },
        { format: 'f', comment: 'Fixed-point' },
        { format: 'g', comment: 'General' },
        { format: 'p', comment: 'Percent' },
        { format: 'x', comment: 'Hexadecimal' }
    ]
};

export const GAUGE_FORMAT_VALUES = {
    default: [
        { value: 'currency', name: 'currency' },
        { value: 'fixedPoint', name: 'fixedPoint' },
        { value: 'percent', name: 'percent' },
        { value: 'decimal', name: 'decimal' },
        { value: 'exponential', name: 'exponential' },
        { value: 'largeNumber', name: 'largeNumber' },
        { value: 'thousands', name: 'thousands' },
        { value: 'millions', name: 'millions' },
        { value: 'billions', name: 'billions' },
        { value: 'trillions', name: 'trillions' }
    ],
    not_set: [
        //{ value: "default", name: "default"}
    ]
};
